import Joi from '@hapi/joi'

export const newSupplierRegisterDetailReportSchema = {
    fromDate: Joi.string().invalid("").label("From Date"),

    toDate: Joi.string().invalid("").label("To Date")

}